import { useCallback, useMemo } from "react";
import { Preview } from "../useMetaPreview";
import { setLayerPreview, setProjectPreview, setTablePreview } from "../../resources/preview";
import { useNotification } from "../notifications/useNotification";

type PreviewMutation = typeof setProjectPreview | typeof setLayerPreview | typeof setTablePreview;

const checkPreviewUpdate = (preview: Preview) => {
  const isUpdate = !!(preview.file && preview.src);
  const isDelete = preview.resourcePreview === undefined && !isUpdate;

  return isDelete || isUpdate;
};

export const usePreviewUpdate = (resourceName: string, preview: Preview, mutation: PreviewMutation) => {
  const needUpdatePreview = checkPreviewUpdate(preview);
  const [setPreview, { loading: previewUpdating, data: previewUpdate, error: previewUpdateError }] = mutation.use();

  const updatePreview = useCallback(() => {
    if (preview && needUpdatePreview) {
      return setPreview({ input: { name: resourceName, preview: preview.file } });
    }
  }, [preview, needUpdatePreview]);

  useNotification(previewUpdateError, {
    error: true,
    title: "Не удалось обновить изображение",
  });

  return useMemo(
    () => ({ updatePreview, previewUpdating, previewUpdate, previewUpdateError, needUpdatePreview }),
    [previewUpdate, needUpdatePreview, updatePreview, previewUpdating, previewUpdateError],
  );
};

export const useProjectPreviewUpdate = (projectName: string, preview: Preview) =>
  usePreviewUpdate(projectName, preview, setProjectPreview);

// TODO
export const useLayerPreviewUpdate = (layerName: string, preview: Preview) =>
  usePreviewUpdate(layerName, preview, setLayerPreview);

export const useTablePreviewUpdate = (tableName: string, preview: Preview) =>
  usePreviewUpdate(tableName, preview, setTablePreview);
